import Points from 'Shared/UI/Points';

export default Points;
